import { Component, OnInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { DecimalPipe } from '@angular/common';
import { P_CampaignStageTitle } from '../../shared.pipe';
import { ReplaySubject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AppService } from '../../../store/app.service';
import { PAGE_NAMES, ROLES, NOTES_TYPE, TAGS_TYPE, CAMPAIGN_STAGES } from '../../../core/helpers/constants';
import { TasksService } from '../../../pages/tasks/tasks.service';
import { ITask } from '../../../core/models/tasks.models';
import { TasksApiService } from '../../../pages/tasks/tasks.apiservice';
import { IPermission, IUser } from '../../../core/models/auth.models';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataFeedService } from '../../api/datafeed.service';
import { AddCampaignCheckModal } from '../../modals/add-campaign-check/add-campaigncheck.component';
import { AddCallNoteModal } from '../../modals/add-call-note/add-call-note.component';
import { SendEmailModal } from '../../modals/send-email/send-email.component';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { CampaignsApiService } from '../../../pages/campaigns/campaigns.apiservice';
import * as moment from 'moment';
import { createGuid, getAuthToken } from '../../../core/helpers/utility';
import { Utility } from '../../utility';
import {
  DashboardStyleSettingsService,
  DashboardStyleState,
  DEFAULT_AI_REWRITE_PROMPT_PREFIX,
  DEFAULT_AI_REWRITE_SYSTEM_CONTENT,
  DEFAULT_AI_REWRITE_TEMPERATURE,
} from '../../services/dashboard-style-settings.service';
import { TagsApiService } from '../../../pages/tags/tags.apiservice';

@Component({
  selector: 'app-dms-dashboard',
  templateUrl: './dms-dashboard.component.html',
  styleUrls: ['./dms-dashboard.component.scss'],
  providers: [DecimalPipe, P_CampaignStageTitle]
})

export class DmsDashboardComponent implements OnInit, OnDestroy {

  @ViewChild('campaignsNoCheckModal') campaignsNoCheckModal!: TemplateRef<any>;
  @ViewChild('clientsNoCallModal') clientsNoCallModal!: TemplateRef<any>;
  @ViewChild('overdueCallsModal') overdueCallsModal!: TemplateRef<any>;

  private readonly redAlertOnlyAutomationId = 999;
  private readonly campaignAuditsAutomationId = 3;
  private readonly googleCampaignChecksAutomationId = 4;
  private readonly facebookCampaignChecksAutomationId = 5;

  // Cache Red Alert checks so task reloads/filters don't re-fetch for the same campaign.
  private readonly redAlertAbortController = new AbortController();
  private readonly redAlertCacheByCampaignId = new Map<string, boolean>();
  private readonly redAlertRequestsByCampaignId = new Map<string, Promise<boolean>>();
  private readonly auditNeededCacheByCampaignId = new Map<string, boolean>();
  private readonly auditNeededRequestsByCampaignId = new Map<string, Promise<boolean>>();
  private readonly campaignPlatformCacheByCampaignId = new Map<string, 'google' | 'facebook' | 'tiktok' | null>();
  private readonly campaignPlatformRequestsByCampaignId = new Map<string, Promise<'google' | 'facebook' | 'tiktok' | null>>();
  readonly weekDayKeys = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];

  backgroundImageStyle: SafeStyle | null = null;

  bgImageOpacityPct = 100;

  cardBgColor = '#ffffff';
  cardBgOpacityPct = 100;

  taskcolBgColor = '#d3d3d3';
  taskcolBgOpacityPct = 100;

  taskHeaderColor = '#495057';
  aiRewritePromptPrefix = DEFAULT_AI_REWRITE_PROMPT_PREFIX;
  aiRewriteSystemContent = DEFAULT_AI_REWRITE_SYSTEM_CONTENT;
  aiRewriteTemperature = DEFAULT_AI_REWRITE_TEMPERATURE;

  doWhat: IPermission = {} as IPermission;
  // activeUser: IUser = {} as IUser;
  allUsers: Array<IUser> = new Array<IUser>();
  ROLES = ROLES;

  searchString = '';
  // dataTotalCount: number = 0;
  myTasks: boolean = true;

  automationsList: Array<{ id: number, name: string, client: string, tasks: string[], platform?: 'google' | 'facebook' }> = [];

  tasksData: Array<ITask>;
  thisWeekTasksData: Array<ITask>;
  overdueTasksData: Array<ITask>;
  futureTasksData: Array<ITask>;

  selectedUserId: string | null = null;
  selectedAutomationId: number | null = null;

  private userScopedTasksForNoCheck: ITask[] = [];

  isCheckingCampaignsWithNoCheck = false;
  campaignsWithNoCheckCount: number | null = null;
  campaignsWithNoCheckError = '';
  campaignsWithNoCheckRows: Array<{
    campaignId: string;
    campaignName: string;
    clientId: string;
    clientName: string;
    stageId: number;
    stageTitle: string;
  }> = [];

  isCheckingClientsWithNoCall = false;
  clientsWithNoCallCount: number | null = null;
  clientsWithNoCallError = '';
  clientsWithNoCallRows: Array<{ clientId: string; clientName: string; campaignCount: number }> = [];

  isCheckingOverdueCalls = false;
  overdueCallsCount: number | null = null;
  overdueCallsError = '';
  overdueCallsRows: Array<{ clientId: string; clientName: string; tier: string; lastCallDate: Date | null; daysSinceCall: number | null }> = [];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  private taskLoadSubscription: Subscription | null = null;
  showNextWeek: boolean = false;
  
  constructor(
    private appService: AppService,
    private dataFeedService: DataFeedService,
    private modalService: NgbModal,
    private tasksService: TasksService,
    private tasksApi: TasksApiService,
    private campaignsApi: CampaignsApiService,
    private sanitizer: DomSanitizer,
    private dashboardStyleSettingsService: DashboardStyleSettingsService,
    private translate: TranslateService,
    private tagsApi: TagsApiService,
  ) {
    this.tasksData = new Array<ITask>();
    this.thisWeekTasksData = new Array<ITask>();
    this.overdueTasksData = new Array<ITask>();
    this.futureTasksData = new Array<ITask>();

    this.automationsList = [
      { id: this.redAlertOnlyAutomationId, name: this.translate.instant('RED_ALERT_ONLY'), client: '', tasks: ['Campaign Check'] },
      { id: 1, name: this.translate.instant('CAMPAIGN_CHECKS'), client: '', tasks: ['Campaign Check'] },
      { id: this.googleCampaignChecksAutomationId, name: this.translate.instant('GOOGLE_CAMPAIGN_CHECKS'), client: '', tasks: ['Campaign Check'], platform: 'google' },
      { id: this.facebookCampaignChecksAutomationId, name: this.translate.instant('FACEBOOK_CAMPAIGN_CHECKS'), client: '', tasks: ['Campaign Check'], platform: 'facebook' },
      { id: 2, name: this.translate.instant('CLIENT_CALLS'), client: '', tasks: ['Call With Client'] },
      { id: this.campaignAuditsAutomationId, name: this.translate.instant('CAMPAIGN_AUDITS'), client: '', tasks: ['Campaign Check'] },
    ];

    this.dataFeedService.getAllTaskAssignees()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        if (response.good) {
          this.allUsers = [...response.data].map((i) => { i.fullName = i.firstName + ' ' + i.lastName; return i; });
          const activeUser: any = this.appService.getActiveUser$().value;
          const activeUserId = String(activeUser?.id ?? '').trim();
          if (activeUserId && this.allUsers.some(user => String(user?.id ?? '').trim() === activeUserId)) {
            this.selectedUserId = activeUserId;
          }
          this.loadTaskData();
          // console.log(this.allUsers);
        } else {
          this.loadTaskData();
        }
      }, () => {
        this.loadTaskData();
      });
  }

  get cardBgRgba(): string {
    return this.hexToRgba(this.cardBgColor, this.cardBgOpacityPct / 100);
  }

  get taskcolBgRgba(): string {
    return this.hexToRgba(this.taskcolBgColor, this.taskcolBgOpacityPct / 100);
  }

  private hexToRgba(hex: string, alpha: number): string {
    const normalized = (hex ?? '').toString().trim();
    const match = /^#?([0-9a-f]{6})$/i.exec(normalized);
    if (!match) {
      return `rgba(255,255,255,${this.clamp01(alpha)})`;
    }

    const intVal = parseInt(match[1], 16);
    const r = (intVal >> 16) & 255;
    const g = (intVal >> 8) & 255;
    const b = intVal & 255;
    return `rgba(${r},${g},${b},${this.clamp01(alpha)})`;
  }

  private clamp01(value: number): number {
    if (!Number.isFinite(value)) return 1;
    return Math.min(1, Math.max(0, value));
  }

  private normalizeTaskTitle(value: unknown): string {
    return String(value ?? '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  private titleMatchesAny(value: unknown, candidates: string[]): boolean {
    const normalizedValue = this.normalizeTaskTitle(value);
    if (!normalizedValue) return false;

    return (candidates ?? [])
      .map(candidate => this.normalizeTaskTitle(candidate))
      .filter(Boolean)
      .some(candidate => normalizedValue.includes(candidate));
  }

  private getCampaignCheckTitleCandidates(): string[] {
    return [
      this.translate.instant('CAMPAIGN_CHECK'),
      'Campaign Check',
      'Verificación de campaña',
    ];
  }

  private getCallWithClientTitleCandidates(): string[] {
    return [
      this.translate.instant('CALL_WITH_CLIENT'),
      'Call With Client',
      'Llamada con el cliente',
    ];
  }

  private getCampaignAuditCompletedTitleCandidates(): string[] {
    return [
      this.translate.instant('CAMPAIGN_AUDIT_COMPLETED'),
      'Campaign Audit Completed',
      'Auditoría de campaña completada',
      this.translate.instant('FULL_CAMPAIGN_AUDIT_COMPLETED'),
      'Full Campaign Audit Completed',
      'Auditoría completa de campaña completada',
    ];
  }

  isCampaignCheckTitle(value: unknown): boolean {
    return this.titleMatchesAny(value, this.getCampaignCheckTitleCandidates());
  }

  isCallWithClientTitle(value: unknown): boolean {
    return this.titleMatchesAny(value, this.getCallWithClientTitleCandidates());
  }

  isCampaignAuditCompletedTitle(value: unknown): boolean {
    return this.titleMatchesAny(value, this.getCampaignAuditCompletedTitleCandidates());
  }

  private applySharedStyleState(state: DashboardStyleState): void {
    this.bgImageOpacityPct = state.bgImageOpacityPct;
    this.cardBgColor = state.cardBgColor;
    this.cardBgOpacityPct = state.cardBgOpacityPct;
    this.taskcolBgColor = state.taskcolBgColor;
    this.taskcolBgOpacityPct = state.taskcolBgOpacityPct;
    this.taskHeaderColor = state.taskHeaderColor;
    this.aiRewritePromptPrefix = state.aiRewritePromptPrefix;
    this.aiRewriteSystemContent = state.aiRewriteSystemContent;
    this.aiRewriteTemperature = state.aiRewriteTemperature;
    this.backgroundImageStyle = state.backgroundImageUrl
      ? this.sanitizer.bypassSecurityTrustStyle(`url("${state.backgroundImageUrl}")`)
      : null;
  }

  private isCampaignCheckPurchaseReporting(campaignCheck: any): boolean {
    return campaignCheck?.reportPurchases === true
      || campaignCheck?.reportPurchases === 'true'
      || campaignCheck?.report_purchases === true
      || campaignCheck?.report_purchases === 'true';
  }

  private getCampaignCheckMetricLabels(campaignCheck: any): {
    leads: string;
    cpl: string;
    lsr: string;
  } {
    if (this.isCampaignCheckPurchaseReporting(campaignCheck)) {
      return {
        leads: 'Conversion Actions',
        cpl: 'CPA',
        lsr: 'Conversion Rate',
      };
    }

    return {
      leads: 'Leads',
      cpl: 'CPL',
      lsr: 'LSR',
    };
  }

  private buildCampaignCheckNoteBody(campaignCheck: any): string {
    const metricNames = this.getCampaignCheckMetricLabels(campaignCheck);
    const platformMetricLabel = campaignCheck?.isGooglePlatform ? 'CPC' : 'CPM';

    return [
      'Last 7 Days:',
      `Impressions: ${campaignCheck?.impression ?? ''} | ${metricNames.leads}: ${campaignCheck?.leads ?? ''} | ${metricNames.cpl}: $${campaignCheck?.cpl ?? ''} | CTR: ${campaignCheck?.ctr ?? ''}% | ${platformMetricLabel}: $${campaignCheck?.cPMOrCPC ?? ''} | ${metricNames.lsr}: ${campaignCheck?.lFSROrLPCR ?? ''}%`,
      '',
      'Insights:',
      `${campaignCheck?.insightText ?? ''}`,
      '',
      'Changes:',
      `${campaignCheck?.changesText ?? ''}`,
    ].join('\n').trim();
  }

  private buildCampaignCheckEmailBody(campaignCheck: any): string {
    const metricLabel = campaignCheck?.isGooglePlatform ? 'CPC' : 'CPM';
    const metricNames = this.getCampaignCheckMetricLabels(campaignCheck);
    const introLines = this.getCampaignCheckEmailIntroLines(campaignCheck);

    return [
      `Hi ${campaignCheck?.clientFirstName ?? ''},`,
      '',
      ...introLines,
      '',
      'What was found:',
      `${campaignCheck?.insightText ?? ''}`,
      '',
      'Key metrics over the last 7 days:',
      `Impressions: ${campaignCheck?.impression ?? ''}`,
      `${metricNames.leads}: ${campaignCheck?.leads ?? ''}`,
      `${metricNames.cpl}: $${campaignCheck?.cpl ?? ''}`,
      `CTR: ${campaignCheck?.ctr ?? ''}%`,
      `${metricLabel}: $${campaignCheck?.cPMOrCPC ?? ''}`,
      `${metricNames.lsr}: ${campaignCheck?.lFSROrLPCR ?? ''}%`,
      '',
      'This is what I am doing:',
      `${campaignCheck?.changesText ?? ''}`,
      '',
      'In the next few days, I\'ll review the campaign again to check if any changes are necessary or if we should let the campaign continue as is.',
      '',
      'You can view your campaign and the updates me and my team make to it by logging into REACH: https://my.reach.marketing. Please don\'t hesitate to reach out to me if you have any questions.',
      '',
      'Best,',
      `${campaignCheck?.assignedUserFirstName ?? ''}`
    ].join('\n').trim();
  }

  private getCampaignCheckEmailIntroLines(campaignCheck: any): string[] {
    const hasAuditItems = Array.isArray(campaignCheck?.campaignAuditItems)
      && campaignCheck.campaignAuditItems.some((item: any) => typeof item === 'string' && item.trim() !== '');
    const hasRedAlertItems = Array.isArray(campaignCheck?.redAlertDeepDiveItems)
      && campaignCheck.redAlertDeepDiveItems.some((item: any) => typeof item === 'string' && item.trim() !== '');

    return hasAuditItems
      ? ['My monthly audit for this campaign has been completed. All key items and fundamental components have been thoroughly reviewed, checked, and verified as correct.']
      : (hasRedAlertItems
        ? ['A thorough review of your campaign was completed.']
        : ['I wanted to provide a quick update on your campaign.']);
  }

  private findUserByFullName(fullName: string): any | null {
    const normalized = String(fullName ?? '').trim().toLowerCase();
    if (!normalized) return null;

    return (this.allUsers ?? []).find((user: any) => {
      const candidate = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim().toLowerCase();
      return candidate === normalized;
    }) ?? null;
  }

  private saveCampaignCheckNote(args: {
    campaignId: string;
    clientId: string;
    campaignCheck: any;
    assignedUserId: string;
    assignedUserName: string;
    addFiles?: Array<{ name: string; content: string }>;
    removeFiles?: string[];
  }): Promise<void> {
    const { campaignId, clientId, campaignCheck, assignedUserId, assignedUserName, addFiles, removeFiles } = args;
    const payload: any = {
      id: createGuid(),
      type: NOTES_TYPE.Campaigns,
      campaignId,
      clientId: null,
      leadId: null,
      assignedUserId,
      assignedUserName,
      title: 'Campaign Check',
      description: this.buildCampaignCheckNoteBody(campaignCheck),
      isInternal: false,
      pin: false,
      createdOn: moment.utc().toDate(),
      addFiles: Array.isArray(addFiles) ? addFiles : [],
      removeFiles: Array.isArray(removeFiles) ? removeFiles : [],
    };

    return new Promise<void>((resolve) => {
      this.dataFeedService.saveNote(payload)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: () => resolve(),
          error: (e: any) => {
            console.error('Error saving campaign check note:', e, payload);
            resolve();
          }
        });
    });
  }

  private createTask(payload: any, logLabel: string): Promise<void> {
    return new Promise<void>((resolve) => {
      this.tasksApi.saveTask(payload)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: () => resolve(),
          error: (e: any) => {
            console.error(`Error saving ${logLabel}:`, e, payload);
            resolve();
          }
        });
    });
  }

  private createFollowUpCampaignCheckTask(args: { campaignId: string; clientId: string; dueDate: any; assignedUserId: string; }): Promise<void> {
    const due = args.dueDate ? new Date(args.dueDate) : null;
    const assignedUserId = String(args.assignedUserId ?? '').trim();
    if (!due || isNaN(due.getTime()) || !assignedUserId) return Promise.resolve();

    const assignedUser = (this.allUsers ?? []).find((u: any) => String(u?.id ?? '').trim() === assignedUserId) ?? null;
    const assignedUserName = `${(assignedUser as any)?.firstName ?? ''} ${(assignedUser as any)?.lastName ?? ''}`.trim();

    const payload: any = {
      id: createGuid(),
      title: 'Campaign Check',
      priority: 2,
      description: 'Do the campaign check for this campaign',
      clientId: args.clientId,
      campaignId: args.campaignId,
      dueDate: Utility.getTaskDueDateFromDateTime(due),
      completedOn: null,
      isCompleted: false,
      assignedUserId,
      assignedUserName,
    };

    return this.createTask(payload, 'campaign check task');
  }

  private createQcCheckTask(args: { campaignId: string; clientId: string; }): Promise<void> {
    const qcUser = this.findUserByFullName('Eliot Lee')
      ?? (this.allUsers ?? []).find((u: any) => `${u?.firstName ?? ''} ${u?.lastName ?? ''}`.trim().toLowerCase().includes('eliot lee'));

    const qcUserId = String((qcUser as any)?.id ?? '').trim();
    if (!qcUserId) return Promise.resolve();

    const payload: any = {
      id: createGuid(),
      title: 'QC Check',
      priority: 1,
      description: 'Please do a QC check on this campaign',
      clientId: args.clientId,
      campaignId: args.campaignId,
      dueDate: Utility.getTaskDueDateFromDateTime(moment.utc().local().add(1, 'day').startOf('day').toDate()),
      completedOn: null,
      isCompleted: false,
      assignedUserId: qcUserId,
      assignedUserName: `${(qcUser as any)?.firstName ?? ''} ${(qcUser as any)?.lastName ?? ''}`.trim() || 'Eliot Lee',
    };

    return this.createTask(payload, 'QC Check task');
  }

  ngOnInit(): void {
    this.dashboardStyleSettingsService.watch('dms')
      .pipe(takeUntil(this.destroyed$))
      .subscribe((state) => this.applySharedStyleState(state));
    this.doWhat = this.appService.getUserRolesForPage(PAGE_NAMES.Tasks);
  }

  ngOnDestroy(): void {
    this.redAlertAbortController.abort();
    this.taskLoadSubscription?.unsubscribe();
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  get campaignsWithNoCheckButtonLabel(): string {
    if (this.campaignsWithNoCheckCount === null) {
      return this.translate.instant('CAMPAIGNS_WITH_NO_CHECK');
    }
    return `${this.campaignsWithNoCheckCount} ${this.translate.instant('CAMPAIGNS_WITH_NO_CHECK')}`;
  }

  get canCheckCampaignsWithNoCheck(): boolean {
    return !!this.getEffectiveUserIdForDashboardScope();
  }

  get clientsWithNoCallButtonLabel(): string {
    return this.clientsWithNoCallCount === null
      ? this.translate.instant('CLIENTS_WITH_NO_CALL')
      : `${this.clientsWithNoCallCount} ${this.translate.instant('CLIENTS_WITH_NO_CALL')}`;
  }

  get overdueCallsButtonLabel(): string {
    return this.overdueCallsCount === null
      ? this.translate.instant('OVERDUE_CALLS')
      : `${this.overdueCallsCount} ${this.translate.instant('OVERDUE_CALLS')}`;
  }

  isTaskDueOnDay(dueDate: string, day: string): boolean {
    const date = new Date(dueDate);
    const dayIndex = this.getDayIndexForWeekKey(day);
    return Number.isInteger(dayIndex) && date.getDay() === dayIndex;
  }

  getTaskCountForDay(day: string): number {
    return this.thisWeekTasksData.filter(task => this.isTaskDueOnDay(task.dueDate, day)).length;
  }

  private getDayIndexForWeekKey(day: string): number {
    switch (day) {
      case 'MONDAY':
        return 1;
      case 'TUESDAY':
        return 2;
      case 'WEDNESDAY':
        return 3;
      case 'THURSDAY':
        return 4;
      case 'FRIDAY':
        return 5;
      default:
        return -1;
    }
  }

  isOverdue(dueDate: string): boolean {
    const today = new Date();
    const taskDueDate = new Date(dueDate);

    // Reset time to 00:00:00 for accurate comparison
    today.setHours(0, 0, 0, 0);
    taskDueDate.setHours(0, 0, 0, 0);

    return taskDueDate < today;
  }

  loadTaskData(search: string | null = null): void {
    this.tasksData = [];
    const searchValue = search ? search : this.searchString;
    const activeUser: any = this.appService.getActiveUser$().value;
    const activeUserId = String(activeUser?.id ?? '').trim();
    const selectedUserId = String(this.selectedUserId ?? '').trim();
    const showOnlyMyTasks = !!activeUserId && selectedUserId === activeUserId;

    this.taskLoadSubscription?.unsubscribe();
    this.taskLoadSubscription = this.tasksApi.getAllTasks({ search: searchValue, showOnlyMyTasks, completion: 1 })
    .pipe(takeUntil(this.destroyed$))
    .subscribe((response: any) => {
      // console.log('tasks data: ', response);
      const allTasks: ITask[] = Array.isArray(response?.data) ? response.data : [];

      const selectedAutomationId = this.selectedAutomationId;
      const selectedUserId = this.selectedUserId;

      // Apply the user filter FIRST to minimize downstream loops/hydration.
      let workingTasks: ITask[] = allTasks;
      if (selectedUserId !== null) {
        workingTasks = workingTasks.filter((task: ITask) => task.assignedUserId === selectedUserId);
      }

      const effectiveUserId = this.getEffectiveUserIdForDashboardScope();
      this.userScopedTasksForNoCheck = effectiveUserId
        ? workingTasks.filter((task: ITask) => task.assignedUserId === effectiveUserId)
        : [];

      // Reset the count label when the dashboard task scope changes.
      this.campaignsWithNoCheckCount = null;
      this.clientsWithNoCallCount = null;
      this.overdueCallsCount = null;

      void (async () => {
        if (selectedAutomationId !== null) {
          if (selectedAutomationId === this.redAlertOnlyAutomationId) {
            // Re-apply cached Red Alert flags onto new task objects.
            this.applyCachedRedAlertFlags(workingTasks);

            // Only hydrate for the (already user-filtered) set.
            await this.hydrateRedAlertFlags(workingTasks);

            workingTasks = workingTasks.filter((task: ITask) => (task as any).isRedAlert === true);
          } else if (selectedAutomationId === this.campaignAuditsAutomationId) {
            // Campaign Audits filter = Campaign Check tasks where audit is currently needed.
            workingTasks = workingTasks.filter((task: ITask) => this.isCampaignCheckTask(task));
            this.applyCachedAuditNeededFlags(workingTasks);
            await this.hydrateAuditNeededFlags(workingTasks);
            workingTasks = workingTasks.filter((task: ITask) => (task as any).isAuditNeeded === true);
          } else if (selectedAutomationId === 2) {
            workingTasks = workingTasks.filter((task: ITask) => this.isCallWithClientTitle(task?.title));
          } else {
            const automation = this.automationsList.find(a => a.id === selectedAutomationId);
            if (automation) {
              workingTasks = workingTasks.filter((task: ITask) =>
                this.isCampaignCheckTitle(task?.title) &&
                (!automation.client || (task.clientName && task.clientName.includes(automation.client)))
              );

              if (automation.platform) {
                workingTasks = await this.filterCampaignChecksByPlatform(workingTasks, automation.platform);
              }
            }
          }
        }

        this.tasksData = this.sortTasksForDashboard(workingTasks);
        this.groupTasksData();
      })();
    });
  }

  private getEffectiveUserIdForDashboardScope(): string | null {
    if (this.selectedUserId) {
      return this.selectedUserId;
    }

    if (!this.myTasks) {
      return null;
    }

    const activeUser: any = this.appService.getActiveUser$().value;
    const id = (activeUser?.id ?? '').toString().trim();
    return id || null;
  }

  private getCampaignStageTitle(stageId: number): string {
    const stage = CAMPAIGN_STAGES.find(x => x.value === stageId);
    return stage?.title ?? '';
  }

  private getActiveOrCancellingCampaignsForUser(userId: string): Promise<any[]> {
    const normalizedUserId = String(userId ?? '').trim();
    if (!normalizedUserId) return Promise.resolve([]);

    return new Promise<any[]>((resolve) => {
      this.campaignsApi.getAllCampaigns({})
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (response: any) => {
            const campaigns = Array.isArray(response?.data) ? response.data : [];
            const filtered = campaigns.filter((campaign: any) => {
              const dmsId = String(campaign?.dmsId ?? '').trim();
              const stageId = Number(campaign?.stageId ?? 0);
              return dmsId === normalizedUserId && (stageId === 6 || stageId === 9);
            });
            resolve(filtered);
          },
          error: () => resolve([]),
        });
    });
  }

  private getOpenTasksForAllUsers(): Promise<ITask[]> {
    return new Promise<ITask[]>((resolve) => {
      this.tasksApi.getAllTasks({ search: '', showOnlyMyTasks: false, completion: 1 })
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (response: any) => resolve(Array.isArray(response?.data) ? response.data : []),
          error: () => resolve([]),
        });
    });
  }

  async onCampaignsWithNoCheckClick(): Promise<void> {
    await this.evaluateCampaignsWithNoCheck(true);
  }

  async onClientsWithNoCallClick(): Promise<void> {
    await this.evaluateClientCallChecks(true);
  }

  async onOverdueCallsClick(): Promise<void> {
    await this.evaluateClientCallChecks(true, true);
  }

  private getClientCallCandidates(campaigns: any[]): Array<{ clientId: string; clientName: string; campaignCount: number }> {
    const clients = new Map<string, { clientId: string; clientName: string; campaignCount: number }>();
    for (const campaign of campaigns ?? []) {
      const clientId = String(campaign?.clientId ?? '').trim();
      if (!clientId) continue;
      const existing = clients.get(clientId);
      if (existing) {
        existing.campaignCount++;
      } else {
        clients.set(clientId, {
          clientId,
          clientName: String(campaign?.clientName ?? '').trim(),
          campaignCount: 1,
        });
      }
    }
    return Array.from(clients.values()).sort((a, b) => this.compareText(a.clientName, b.clientName));
  }

  private getClientNotes(clientId: string): Promise<any[]> {
    return new Promise<any[]>(resolve => {
      this.dataFeedService.getNotes(clientId, NOTES_TYPE.Clients)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({ next: (response: any) => resolve(Array.isArray(response?.data) ? response.data : (Array.isArray(response) ? response : [])), error: () => resolve([]) });
    });
  }

  private getClientTags(clientId: string): Promise<any[]> {
    return new Promise<any[]>(resolve => {
      this.tagsApi.getAssociatedTags(clientId, TAGS_TYPE.Clients)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({ next: (response: any) => resolve(Array.isArray(response?.data) ? response.data : (Array.isArray(response) ? response : [])), error: () => resolve([]) });
    });
  }

  private getLatestCallNote(notes: any[]): Date | null {
    const dates = (notes ?? [])
      .filter(note => this.normalizeTaskTitle(note?.title) === 'call note')
      .map(note => this.tryGetMeaningfulNoteDate(note))
      .filter((date): date is Date => !!date);
    return dates.length ? new Date(Math.max(...dates.map(date => date.getTime()))) : null;
  }

  private getClientTier(tags: any[]): 'Basic' | 'Standard' | 'Premium' | null {
    const tierTag = (tags ?? []).find(tag => /tiered pricing\s*\|\s*(basic|standard|premium) tier/i.test(String(tag?.name ?? '')));
    const name = String(tierTag?.name ?? '').toLowerCase();
    if (name.includes('basic')) return 'Basic';
    if (name.includes('standard')) return 'Standard';
    if (name.includes('premium')) return 'Premium';
    return null;
  }

  private hasClientCallExclusionTag(tags: any[]): boolean {
    const excludedTags = ['opted out of calls', 'no calls'];
    return (tags ?? []).some(tag => {
      const normalizedTagName = this.normalizeTaskTitle(tag?.name);
      return excludedTags.some(excludedTag => normalizedTagName.includes(excludedTag));
    });
  }

  private async evaluateClientCallChecks(openModal: boolean, overdueOnly = false): Promise<void> {
    const effectiveUserId = this.getEffectiveUserIdForDashboardScope();
    const errorKey = 'SELECT_A_USER_TO_CHECK_CAMPAIGNS';
    if (overdueOnly) {
      this.overdueCallsError = '';
      this.overdueCallsRows = [];
    } else {
      this.clientsWithNoCallError = '';
      this.clientsWithNoCallRows = [];
    }
    if (!effectiveUserId) {
      if (overdueOnly) this.overdueCallsError = this.translate.instant(errorKey);
      else this.clientsWithNoCallError = this.translate.instant(errorKey);
      if (openModal) this.modalService.open(overdueOnly ? this.overdueCallsModal : this.clientsNoCallModal, { size: 'lg', backdrop: 'static' });
      return;
    }

    if (overdueOnly) this.isCheckingOverdueCalls = true;
    else this.isCheckingClientsWithNoCall = true;
    try {
      const campaigns = await this.getActiveOrCancellingCampaignsForUser(effectiveUserId);
      const candidates = this.getClientCallCandidates(campaigns);
      const openTasks = await this.getOpenTasksForAllUsers();
      const clientsWithCallTask = new Set((openTasks ?? []).filter(task => this.isCallWithClientTitle(task?.title)).map(task => String(task?.clientId ?? '').trim()).filter(Boolean));
      const snapshots = await Promise.all(candidates.map(async client => ({ client, notes: await this.getClientNotes(client.clientId), tags: await this.getClientTags(client.clientId) })));

      const missingCallRows = snapshots
        .filter(({ client, tags }) => this.getClientTier(tags) !== 'Basic'
          && !this.hasClientCallExclusionTag(tags)
          && !clientsWithCallTask.has(client.clientId))
        .map(({ client }) => client);
      const overdueRows = snapshots.map(({ client, notes, tags }) => {
        const tier = this.getClientTier(tags);
        const lastCallDate = this.getLatestCallNote(notes);
        const daysSinceCall = lastCallDate ? Math.floor((Date.now() - lastCallDate.getTime()) / 86400000) : null;
        const threshold = tier === 'Standard' ? 31 : 16;
        return tier !== 'Basic'
          && !this.hasClientCallExclusionTag(tags)
          && (daysSinceCall === null || daysSinceCall >= threshold)
          ? { clientId: client.clientId, clientName: client.clientName, tier: tier ?? 'No tier', lastCallDate, daysSinceCall }
          : null;
      }).filter((row): row is { clientId: string; clientName: string; tier: string; lastCallDate: Date | null; daysSinceCall: number | null } => !!row);

      if (overdueOnly) {
        this.overdueCallsRows = overdueRows;
        this.overdueCallsCount = overdueRows.length;
      } else {
        this.clientsWithNoCallRows = missingCallRows;
        this.clientsWithNoCallCount = missingCallRows.length;
      }
    } catch {
      if (overdueOnly) { this.overdueCallsError = this.translate.instant('UNABLE_TO_EVALUATE_OVERDUE_CALLS'); this.overdueCallsCount = null; }
      else { this.clientsWithNoCallError = this.translate.instant('UNABLE_TO_EVALUATE_CLIENTS_WITH_NO_CALL'); this.clientsWithNoCallCount = null; }
    } finally {
      if (overdueOnly) this.isCheckingOverdueCalls = false;
      else this.isCheckingClientsWithNoCall = false;
      if (openModal) this.modalService.open(overdueOnly ? this.overdueCallsModal : this.clientsNoCallModal, { size: 'lg', backdrop: 'static' });
    }
  }

  private async evaluateCampaignsWithNoCheck(openModal: boolean): Promise<void> {
    this.campaignsWithNoCheckError = '';
    this.campaignsWithNoCheckRows = [];

    const effectiveUserId = this.getEffectiveUserIdForDashboardScope();
    if (!effectiveUserId) {
      this.campaignsWithNoCheckError = this.translate.instant('SELECT_A_USER_TO_CHECK_CAMPAIGNS');
      if (openModal) {
        this.modalService.open(this.campaignsNoCheckModal, {
          size: 'lg',
          backdrop: 'static',
        });
      }
      return;
    }

    this.isCheckingCampaignsWithNoCheck = true;

    try {
      const campaigns = await this.getActiveOrCancellingCampaignsForUser(effectiveUserId);
      const openTasksAllUsers = await this.getOpenTasksForAllUsers();

      const campaignIdsWithCheckTask = new Set(
        (openTasksAllUsers ?? [])
          .filter((task) => this.isCampaignCheckTitle(task?.title))
          .map((task) => String(task.campaignId ?? '').trim())
          .filter((id) => !!id)
      );

      const rows = (campaigns ?? [])
        .filter((campaign: any) => {
          if (!this.isSupportedCampaignPlatform(campaign?.platform ?? campaign?.Platform)) {
            return false;
          }

          const campaignId = String(campaign?.id ?? '').trim();
          if (!campaignId) return false;
          return !campaignIdsWithCheckTask.has(campaignId);
        })
        .map((campaign: any) => ({
          campaignId: String(campaign?.id ?? ''),
          campaignName: String(campaign?.name ?? '').trim(),
          clientId: String(campaign?.clientId ?? ''),
          clientName: String(campaign?.clientName ?? '').trim(),
          stageId: Number(campaign?.stageId ?? 0),
          stageTitle: this.getCampaignStageTitle(Number(campaign?.stageId ?? 0)),
        }))
        .sort((a, b) => {
          const clientCompare = a.clientName.localeCompare(b.clientName, undefined, { sensitivity: 'base', numeric: true });
          if (clientCompare !== 0) return clientCompare;

          return a.campaignName.localeCompare(b.campaignName, undefined, { sensitivity: 'base', numeric: true });
        });

      this.campaignsWithNoCheckRows = rows;
      this.campaignsWithNoCheckCount = rows.length;
    } catch {
      this.campaignsWithNoCheckError = this.translate.instant('UNABLE_TO_EVALUATE_CAMPAIGNS_WITH_NO_CHECK_RIGHT_NOW');
      this.campaignsWithNoCheckRows = [];
      this.campaignsWithNoCheckCount = null;
    } finally {
      this.isCheckingCampaignsWithNoCheck = false;

      if (openModal) {
        this.modalService.open(this.campaignsNoCheckModal, {
          size: 'lg',
          backdrop: 'static',
        });
      }
    }
  }

  private sortTasksForDashboard(tasks: ITask[]): ITask[] {
    return [...(tasks ?? [])].sort((a: ITask, b: ITask) => {
      const titleCompare = this.compareText(a?.title, b?.title);
      if (titleCompare !== 0) return titleCompare;

      const clientCompare = this.compareText(a?.clientName, b?.clientName);
      if (clientCompare !== 0) return clientCompare;

      const campaignCompare = this.compareText(a?.campaignName, b?.campaignName);
      if (campaignCompare !== 0) return campaignCompare;

      return this.compareText((a as any)?.id, (b as any)?.id);
    });
  }

  private compareText(left: any, right: any): number {
    return String(left ?? '').trim().localeCompare(String(right ?? '').trim(), undefined, {
      sensitivity: 'base',
      numeric: true,
    });
  }

  private normalizeCampaignPlatform(platform: unknown): 'google' | 'facebook' | 'tiktok' | null {
    const normalized = String(platform ?? '').trim().toLowerCase();
    if (!normalized) return null;
    if (normalized.includes('google')) return 'google';
    if (normalized.includes('facebook') || normalized.includes('meta')) return 'facebook';
    if (normalized.includes('tiktok')) return 'tiktok';
    return null;
  }

  private getCampaignPlatform(campaignId: string): Promise<'google' | 'facebook' | 'tiktok' | null> {
    const normalizedCampaignId = String(campaignId ?? '').trim();
    if (!normalizedCampaignId) return Promise.resolve(null);

    const cached = this.campaignPlatformCacheByCampaignId.get(normalizedCampaignId);
    if (cached !== undefined) {
      return Promise.resolve(cached);
    }

    const inFlight = this.campaignPlatformRequestsByCampaignId.get(normalizedCampaignId);
    if (inFlight) {
      return inFlight;
    }

    const request = new Promise<'google' | 'facebook' | 'tiktok' | null>((resolve) => {
      this.campaignsApi.getCampaignDetails(normalizedCampaignId)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (response: any) => {
            const platform = this.normalizeCampaignPlatform(response?.data?.platform ?? response?.platform);
            this.campaignPlatformCacheByCampaignId.set(normalizedCampaignId, platform);
            resolve(platform);
          },
          error: () => {
            this.campaignPlatformCacheByCampaignId.set(normalizedCampaignId, null);
            resolve(null);
          }
        });
    }).finally(() => {
      this.campaignPlatformRequestsByCampaignId.delete(normalizedCampaignId);
    });

    this.campaignPlatformRequestsByCampaignId.set(normalizedCampaignId, request);
    return request;
  }

  private async filterCampaignChecksByPlatform(tasks: ITask[], platform: 'google' | 'facebook'): Promise<ITask[]> {
    const filtered = await Promise.all((tasks ?? []).map(async (task) => {
      if (!this.isCampaignCheckTitle(task?.title)) return null;
      if (!task?.campaignId) return null;

      const taskPlatform = await this.getCampaignPlatform(String(task.campaignId));
      return taskPlatform === platform ? task : null;
    }));

    return filtered.filter((task): task is ITask => !!task);
  }

  private isSupportedCampaignPlatform(platform: unknown): boolean {
    const normalized = this.normalizeCampaignPlatform(platform);
    return normalized === 'google' || normalized === 'facebook' || normalized === 'tiktok';
  }

  private isCampaignCheckTask(task: ITask | null | undefined): boolean {
    return !!task?.campaignId && this.isCampaignCheckTitle(task?.title);
  }

  private tryGetMeaningfulNoteDate(note: any): Date | null {
    const createdRaw = note?.createdOn ?? null;
    const created = createdRaw ? new Date(createdRaw) : null;
    if (created && !isNaN(created.getTime()) && created.getFullYear() >= 2000) {
      return created;
    }

    const updatedRaw = note?.updatedOn ?? null;
    const updated = updatedRaw ? new Date(updatedRaw) : null;
    if (updated && !isNaN(updated.getTime()) && updated.getFullYear() >= 2000) {
      return updated;
    }

    return null;
  }

  private evaluateAuditNeededFromCampaignNotes(notes: any[]): boolean {
    const nowLocal = moment.utc().local();
    const previousMonthLocal = nowLocal.clone().subtract(1, 'month');

    const safeNotes = Array.isArray(notes) ? notes : [];

    const hasCampaignCheckLastMonth = safeNotes.some((note: any) => {
      if (!this.isCampaignCheckTitle(note?.title)) return false;

      const dt = this.tryGetMeaningfulNoteDate(note);
      if (!dt) return false;

      return moment.utc(dt).local().isSame(previousMonthLocal, 'month');
    });

    const hasCampaignAuditThisMonth = safeNotes.some((note: any) => {
      if (!this.isCampaignAuditCompletedTitle(note?.title)) return false;

      const dt = this.tryGetMeaningfulNoteDate(note);
      if (!dt) return false;

      return moment.utc(dt).local().isSame(nowLocal, 'month');
    });

    return hasCampaignCheckLastMonth && !hasCampaignAuditThisMonth;
  }

  private applyCachedAuditNeededFlags(tasks: ITask[]): void {
    for (const task of tasks ?? []) {
      const campaignId = String((task as any)?.campaignId ?? '').trim();
      if (!campaignId) continue;

      const cached = this.auditNeededCacheByCampaignId.get(campaignId);
      if (typeof cached !== 'boolean') continue;

      (task as any).isAuditNeeded = cached;
      (task as any).__auditNeededChecked = true;
    }
  }

  private applyCachedRedAlertFlags(tasks: ITask[]): void {
    for (const task of tasks ?? []) {
      const campaignId = (task as any)?.campaignId;
      if (!campaignId) continue;

      const cached = this.redAlertCacheByCampaignId.get(String(campaignId));
      if (typeof cached !== 'boolean') continue;

      (task as any).isRedAlert = cached;
      (task as any).__redAlertChecked = true;
    }
  }

  toggleWeekView() {
    this.showNextWeek = !this.showNextWeek;
    this.groupTasksData();
  }

  groupTasksData() {
    const today = new Date();
    const dayOfWeek = today.getDay();
    let monday = new Date(today);
    let friday = new Date(today);

    if (this.showNextWeek) {
      // Move to next week's Monday
      const daysUntilNextMonday = ((8 - dayOfWeek) % 7) || 7;
      monday.setDate(today.getDate() + daysUntilNextMonday);
      friday = new Date(monday);
      friday.setDate(monday.getDate() + 4);
    } else {
      // This week
      monday.setDate(today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
      friday = new Date(monday);
      friday.setDate(monday.getDate() + 4);
    }

    // Reset time to 00:00:00 for accurate comparison
    monday.setHours(0, 0, 0, 0);
    friday.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    this.thisWeekTasksData = [];
    this.overdueTasksData = [];
    this.futureTasksData = [];
    
    this.tasksData.forEach(task => {
      const dueDate = new Date(task.dueDate);
      dueDate.setHours(0, 0, 0, 0); // Reset time to 00:00:00 for accurate comparison
      if (!this.showNextWeek) {
        if (dueDate < monday) {
          this.overdueTasksData.push(task);
        } else if (dueDate >= monday && dueDate <= friday) {
          this.thisWeekTasksData.push(task);
        } else if (dueDate > friday) {
          this.futureTasksData.push(task);
        }
      } else {
        // Next week
        if (dueDate < monday) {
          this.overdueTasksData.push(task);
        } else if (dueDate >= monday && dueDate <= friday) {
          this.thisWeekTasksData.push(task);
        } else if (dueDate > friday) {
          this.futureTasksData.push(task);
        }
      }

      if (this.isCampaignCheckTask(task)) {
        this.checkAuditNeededForCampaignCheck(task);
        this.checkRedAlertForCampaignCheck(task);
      }

    });
  }

  private checkAuditNeededForCampaignCheck(task: ITask): void {
    if (!this.isCampaignCheckTask(task)) return;

    const campaignId = String((task as any).campaignId);

    const cached = this.auditNeededCacheByCampaignId.get(campaignId);
    if (typeof cached === 'boolean') {
      (task as any).isAuditNeeded = cached;
      (task as any).__auditNeededChecked = true;
      return;
    }

    if ((task as any).__auditNeededChecked === true) return;

    void this.getAuditNeededForCampaign(campaignId)
      .then((isAuditNeeded: boolean) => {
        (task as any).isAuditNeeded = isAuditNeeded;
        (task as any).__auditNeededChecked = true;
      })
      .catch(() => {
        (task as any).isAuditNeeded = false;
        (task as any).__auditNeededChecked = true;
      });
  }

  private getAuditNeededForCampaign(campaignId: string): Promise<boolean> {
    const cached = this.auditNeededCacheByCampaignId.get(campaignId);
    if (typeof cached === 'boolean') {
      return Promise.resolve(cached);
    }

    const inFlight = this.auditNeededRequestsByCampaignId.get(campaignId);
    if (inFlight) {
      return inFlight;
    }

    const request = new Promise<boolean>((resolve, reject) => {
      this.dataFeedService.getNotes(campaignId, NOTES_TYPE.Campaigns)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (response: any) => {
            const notes = Array.isArray(response?.data) ? response.data : [];
            const isAuditNeeded = this.evaluateAuditNeededFromCampaignNotes(notes);
            this.auditNeededCacheByCampaignId.set(campaignId, isAuditNeeded);
            resolve(isAuditNeeded);
          },
          error: reject
        });
    }).finally(() => {
      this.auditNeededRequestsByCampaignId.delete(campaignId);
    });

    this.auditNeededRequestsByCampaignId.set(campaignId, request);
    return request;
  }

  private parseIsRedAlert(value: any): boolean {
    if (value === true) return true;
    if (value === false || value === null || typeof value === 'undefined') return false;
    return Number(value) === 1;
  }

  private async requestTarsRedAlert(reachCampaignId: string): Promise<boolean> {
    const authToken = getAuthToken();
    if (!authToken) throw new Error('The logged-in user auth token is not available.');

    const response = await fetch('https://dms.reach.marketing/tars/reach-check-redalert-api.php', {
      method: 'POST',
      signal: this.redAlertAbortController.signal,
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ reach_campaign_id: reachCampaignId }),
    });

    const rawBody = await response.text();
    let data: any;
    try {
      data = rawBody.trim() ? JSON.parse(rawBody) : null;
    } catch {
      throw new Error(`TARS Red Alert returned invalid JSON (HTTP ${response.status}).`);
    }
    if (!response.ok) {
      const message = data?.error?.message ?? `TARS Red Alert request failed (HTTP ${response.status}).`;
      throw new Error(message);
    }
    return this.parseIsRedAlert(data?.isRedAlert);
  }

  private getRedAlertForCampaign(campaignId: string): Promise<boolean> {
    const cached = this.redAlertCacheByCampaignId.get(campaignId);
    if (typeof cached === 'boolean') {
      return Promise.resolve(cached);
    }

    const inFlight = this.redAlertRequestsByCampaignId.get(campaignId);
    if (inFlight) {
      return inFlight;
    }

    const request = this.requestTarsRedAlert(campaignId)
      .then((isRedAlert: boolean) => {
        this.redAlertCacheByCampaignId.set(campaignId, isRedAlert);
        return isRedAlert;
      })
      .finally(() => {
        this.redAlertRequestsByCampaignId.delete(campaignId);
      });

    this.redAlertRequestsByCampaignId.set(campaignId, request);
    return request;
  }

  checkRedAlertForCampaignCheck(task: ITask) {
    if (!task?.campaignId) return;
    const campaignId = String(task.campaignId);

    // Fast path: if we already know the value, don't fetch.
    const cached = this.redAlertCacheByCampaignId.get(campaignId);
    if (typeof cached === 'boolean') {
      (task as any).isRedAlert = cached;
      (task as any).__redAlertChecked = true;
      return;
    }

    if ((task as any).__redAlertChecked === true) return;

    void this.getRedAlertForCampaign(campaignId)
      .then((isRedAlert: boolean) => {
        (task as any).isRedAlert = isRedAlert;
        (task as any).__redAlertChecked = true;
      })
      .catch(error => {
        if (error?.name === 'AbortError') return;

        console.error('Error checking red alert status:', error);
        (task as any).isRedAlert = false;
        (task as any).__redAlertChecked = true;
      });
  }

  private async hydrateRedAlertFlags(tasks: ITask[]): Promise<void> {
    const campaignChecks = (tasks ?? [])
      .filter(t => !!t?.campaignId && this.isCampaignCheckTitle(t?.title));

    await Promise.all(campaignChecks.map(async (task) => {
      if ((task as any).__redAlertChecked === true) return;

      const campaignId = String((task as any).campaignId);
      const cached = this.redAlertCacheByCampaignId.get(campaignId);
      if (typeof cached === 'boolean') {
        (task as any).isRedAlert = cached;
        (task as any).__redAlertChecked = true;
        return;
      }

      try {
        const isRedAlert = await this.getRedAlertForCampaign(campaignId);
        (task as any).isRedAlert = isRedAlert;
        (task as any).__redAlertChecked = true;
      } catch {
        // ignore
        (task as any).isRedAlert = false;
        (task as any).__redAlertChecked = true;
      }
    }));
  }

  private async hydrateAuditNeededFlags(tasks: ITask[]): Promise<void> {
    const campaignChecks = (tasks ?? []).filter(t => this.isCampaignCheckTask(t));

    const tasksByCampaignId = new Map<string, ITask[]>();
    for (const task of campaignChecks) {
      const campaignId = String((task as any).campaignId);
      const existing = tasksByCampaignId.get(campaignId) ?? [];
      existing.push(task);
      tasksByCampaignId.set(campaignId, existing);
    }

    await Promise.all(Array.from(tasksByCampaignId.entries()).map(async ([campaignId, campaignTasks]) => {
      const cached = this.auditNeededCacheByCampaignId.get(campaignId);
      if (typeof cached === 'boolean') {
        for (const task of campaignTasks) {
          (task as any).isAuditNeeded = cached;
          (task as any).__auditNeededChecked = true;
        }
        return;
      }

      try {
        const isAuditNeeded = await this.getAuditNeededForCampaign(campaignId);
        for (const task of campaignTasks) {
          (task as any).isAuditNeeded = isAuditNeeded;
          (task as any).__auditNeededChecked = true;
        }
      } catch {
        for (const task of campaignTasks) {
          (task as any).isAuditNeeded = false;
          (task as any).__auditNeededChecked = true;
        }
      }
    }));
  }

  onAddTaskClick(action: any) {
    const modalRef: NgbModalRef = this.tasksService.openEditTaskModal({ id: action === 'add' ? null : -1 }, true, true);
    modalRef.componentInstance.oSaveClicked.pipe(
      takeUntil(this.destroyed$),
      debounceTime(500)
    ).subscribe(() => {
      this.loadTaskData();
    });
  }

  viewTask(evt: any) {
    const title = (evt?.title ?? '').trim();

    if (this.isCampaignCheckTitle(title)) {
      this.openCampaignCheckModal(evt);
      return;
    }
    if (this.isCallWithClientTitle(title)) {
      this.openCallNoteModal(evt);
      return;
    }

    this.openTaskEditModal(evt);
  }

  private openTaskEditModal(evt: any): void {
    const modalRef: NgbModalRef = this.tasksService.openEditTaskModal(evt);
    modalRef.componentInstance.oSaveClicked
      .pipe(takeUntil(this.destroyed$), debounceTime(500))
      .subscribe(() => this.loadTaskData());

    modalRef.componentInstance.oDeleteClicked
      .pipe(takeUntil(this.destroyed$), debounceTime(500))
      .subscribe(() => this.loadTaskData());

    modalRef.componentInstance.oMarkAsCompleteClicked
      .pipe(takeUntil(this.destroyed$), debounceTime(500))
      .subscribe(() => this.loadTaskData());
  }

  openCampaignCheckModal(evt: any): void {
    const campaignId = evt?.campaignId;
    const clientId = evt?.clientId;

    if (!campaignId || !clientId) {
      this.openTaskEditModal(evt);
      return;
    }

    const dialogRef = this.modalService.open(AddCampaignCheckModal, {
      size: 'xl',
      windowClass: 'modal-xxl',
      backdrop: 'static',
    });

    dialogRef.componentInstance.iCampaignId = campaignId;
    dialogRef.componentInstance.iClientId = clientId;
    dialogRef.componentInstance.iType = 1;
    dialogRef.componentInstance.iTask = evt;

    dialogRef.componentInstance.oSaveClicked
      .pipe(takeUntil(this.destroyed$))
      .subscribe((request: any) => {
        (async () => {
          dialogRef.dismiss();

          const triggerTaskId = (evt?.id ?? request?.taskIdToComplete ?? '').toString().trim();
          await this.tryMarkTaskComplete(triggerTaskId);

          const nextAssigneeId = (request?.nextTaskAssignedUserId ?? '').toString().trim();
          if (nextAssigneeId && request?.addTaskDate) {
            await this.createFollowUpCampaignCheckTask({
              campaignId,
              clientId,
              dueDate: request.addTaskDate,
              assignedUserId: nextAssigneeId,
            });
          }

          const activeUser: any = this.appService.getActiveUser$().value;
          const assignedUserId = (activeUser?.id ?? '').toString().trim();
          const assignedUserName = `${activeUser?.firstName ?? ''} ${activeUser?.lastName ?? ''}`.trim();

          if (assignedUserId) {
            await this.saveCampaignCheckNote({
              campaignId,
              clientId,
              campaignCheck: request,
              assignedUserId,
              assignedUserName,
              addFiles: request?.addFiles ?? [],
              removeFiles: request?.removeFiles ?? [],
            });
          }

          const auditItems: string[] = Array.isArray(request?.campaignAuditItems)
            ? request.campaignAuditItems.filter((x: any) => typeof x === 'string' && x.trim() !== '')
            : [];
          const auditAdditionalInfo = String(request?.campaignAuditAdditionalInfo ?? '').trim();

          const redAlertItems: string[] = Array.isArray(request?.redAlertDeepDiveItems)
            ? request.redAlertDeepDiveItems.filter((x: any) => typeof x === 'string' && x.trim() !== '')
            : [];

          if (auditItems.length > 0 || auditAdditionalInfo || redAlertItems.length > 0) {
            if (assignedUserId) {
              const noteCalls: any[] = [];

              if (auditItems.length > 0 || auditAdditionalInfo) {
                const noteRequest: any = {
                  id: createGuid(),
                  type: NOTES_TYPE.Campaigns,
                  campaignId,
                  clientId: null,
                  leadId: null,
                  assignedUserId,
                  assignedUserName,
                  title: 'Campaign Audit Completed',
                  description: this.formatCampaignAuditInternalNote(auditItems, auditAdditionalInfo),
                  isInternal: true,
                  pin: false,
                  createdOn: moment.utc().toDate(),
                  addFiles: [],
                  removeFiles: [],
                };
                noteCalls.push(
                  this.dataFeedService.saveNote(noteRequest)
                    .pipe(takeUntil(this.destroyed$))
                );
              }

              if (redAlertItems.length > 0) {
                const noteRequest: any = {
                  id: createGuid(),
                  type: NOTES_TYPE.Campaigns,
                  campaignId,
                  clientId: null,
                  leadId: null,
                  assignedUserId,
                  assignedUserName,
                  title: 'Red Alert Deep Dive',
                  description: this.formatRedAlertDeepDiveInternalNote(redAlertItems),
                  isInternal: true,
                  pin: false,
                  createdOn: moment.utc().toDate(),
                  addFiles: [],
                  removeFiles: [],
                };
                noteCalls.push(
                  this.dataFeedService.saveNote(noteRequest)
                    .pipe(takeUntil(this.destroyed$))
                );
              }

              for (const call$ of noteCalls) {
                call$.subscribe({
                  next: () => {},
                  error: (e: any) => console.error('Error saving internal note:', e)
                });
              }
            }
          }

          if (request?.isQCCheck) {
            await this.createQcCheckTask({ campaignId, clientId });
          }

          this.loadTaskData();
          this.openSendEmailModalFromCampaignCheck({
            campaignId,
            clientId,
            campaignCheck: request
          });
        })().catch((e: any) => console.error('Error completing campaign check workflow:', e));
      });

    dialogRef.componentInstance.oTaskUpdated
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.loadTaskData();
      });
  }

  private reassignNextCampaignCheckTask(campaignId: string, dueDateIso: string, assignedUserId: string): Promise<void> {
    const targetDue = new Date(dueDateIso);
    if (!campaignId || !assignedUserId || isNaN(targetDue.getTime())) return Promise.resolve();

    // Never block the email modal on reassignment failures.
    return new Promise<void>((resolve) => {
      this.tasksApi.getTasksByCampaign(campaignId)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (response: any) => {
            const tasks: Array<any> = response?.data ?? [];
            const candidates = tasks
              .filter(t => this.isCampaignCheckTitle(t?.title) && (t?.isCompleted === null || t?.isCompleted === false))
              .map(t => {
                const due = new Date(t?.dueDate);
                return { task: t, diff: Math.abs(due.getTime() - targetDue.getTime()) };
              })
              .filter(x => Number.isFinite(x.diff))
              .sort((a, b) => a.diff - b.diff);

            const best = candidates[0];
            // Safety: if we can't find something close-ish, don't risk reassigning the wrong task.
            if (!best || best.diff > 36 * 60 * 60 * 1000) {
              resolve();
              return;
            }

            // Already assigned to the desired user (e.g., campaign DMS). Nothing to do.
            if ((best.task?.assignedUserId ?? null) === assignedUserId) {
              resolve();
              return;
            }

            this.tasksApi.getTaskDetails(best.task.id)
              .pipe(takeUntil(this.destroyed$))
              .subscribe({
                next: (detailsResp: any) => {
                  const task = detailsResp?.data;
                  if (!task?.id) {
                    resolve();
                    return;
                  }

                  // Double-check on the full task payload before saving.
                  if ((task?.assignedUserId ?? null) === assignedUserId) {
                    resolve();
                    return;
                  }

                  task.assignedUserId = assignedUserId;
                  this.tasksApi.saveTask(task)
                    .pipe(takeUntil(this.destroyed$))
                    .subscribe({
                      next: () => {
                        this.loadTaskData();
                        resolve();
                      },
                      error: () => resolve()
                    });
                },
                error: () => resolve()
              });
          },
          error: () => resolve()
        });
    });
  }

  private async openSendEmailModalFromCampaignCheck(args: { campaignId: string; clientId: string; campaignCheck: any }): Promise<void> {
    const { campaignId, clientId, campaignCheck } = args;

    const fallbackDescription = this.buildCampaignCheckEmailBody(campaignCheck);

    const emailRef = this.modalService.open(SendEmailModal, {
      size: 'xl',
      backdrop: 'static',
    });

    emailRef.componentInstance.iCampaignId = campaignId;
    emailRef.componentInstance.iClientId = clientId;
    emailRef.componentInstance.iType = NOTES_TYPE.Campaigns;
    // console.log('Campaign Check data for email modal: ', campaignCheck);

    const platform = campaignCheck?.isGooglePlatform ? 'Google' : 'Meta';
    emailRef.componentInstance.iSubject = campaignCheck ? `Campaign Performance Update - ${campaignCheck.campaignName} - ${platform}` : 'Campaign Performance Update';

    emailRef.componentInstance.iNote = {
      title: 'Campaign Check Email Sent',
      description: 'One moment please while we generate a draft email for you to review and send...',
      isInternal: false,
      pin: false,
    } as any;

    emailRef.componentInstance.iFromName = `${campaignCheck?.assignedUserFirstName ?? ''} ${campaignCheck?.assignedUserLastName ?? ''}`.trim();

    const recipientName = `${campaignCheck?.clientFirstName ?? ''}`.trim();
    const senderName = `${campaignCheck?.assignedUserFirstName ?? ''}`.trim();
    const draft = campaignCheck ? fallbackDescription : '';
    const isPurchaseReporting = this.isCampaignCheckPurchaseReporting(campaignCheck);
    const metricGlossary = isPurchaseReporting
      ? 'CPA means Cost Per Acquisition; Conversion Rate means conversion rate; CTR means Click-Through Rate; CPC means Cost Per Click; CPM means Cost Per Thousand Impressions.'
      : 'CPL means Cost Per Lead; LSR means Lead Submission Rate (never lead-to-sale rate or any other meaning); CTR means Click-Through Rate; CPC means Cost Per Click; CPM means Cost Per Thousand Impressions.';
    const rewritePromptPrefix = String(this.aiRewritePromptPrefix ?? '').trim() || DEFAULT_AI_REWRITE_PROMPT_PREFIX;
    const rewriteSystemContent = String(this.aiRewriteSystemContent ?? '').trim() || DEFAULT_AI_REWRITE_SYSTEM_CONTENT;
    const rewriteTemperature = Number.isFinite(Number(this.aiRewriteTemperature))
      ? Math.min(Math.max(Number(this.aiRewriteTemperature), 0), 1.4)
      : DEFAULT_AI_REWRITE_TEMPERATURE;

    emailRef.componentInstance.iAiRewriteSystemContent = rewriteSystemContent;
    emailRef.componentInstance.iAiRewritePrompt = `${rewritePromptPrefix}

Recipient (To): ${recipientName || '[not provided]'}
Sender (From): ${senderName || '[not provided]'}

Use the exact Recipient (To) name in the greeting and the exact Sender (From) name in the sign-off. Do not substitute, reorder, shorten, or invent either name. Return only the rewritten email body, with no subject or labels such as "To:" or "From:".

Campaign metric terminology is authoritative: ${metricGlossary} Never infer, redefine, or substitute a metric abbreviation's meaning. Preserve the supplied metric values and do not add metrics, results, or campaign details that are not in the email template.

Here is the email template:

${draft}`;
    emailRef.componentInstance.iAiRewriteTemperature = rewriteTemperature;
    emailRef.componentInstance.aiRewriteModel = campaignCheck?.aiRewriteModel || 'gpt-5';
    if (draft && campaignCheck?.isAIEmail !== false) {
      emailRef.componentInstance.generateDraftWithOverlay();
    } else {
      emailRef.componentInstance.emailForm?.get('description')?.setValue(fallbackDescription);
    }
  }

  private buildCallRecapEmailBody(callNote: any): string {
    const firstName = (callNote?.clientFirstName ?? '').toString().trim();
    const callNotes = (callNote?.callNotes ?? '').toString().trim();
    const nextAction = (callNote?.nextAction ?? '').toString().trim();
    const assignedFirstName = (callNote?.assignedUserFirstName ?? '').toString().trim();
    const nextCall = callNote?.addTaskDate ? moment.utc(callNote.addTaskDate).format('MM/DD/YYYY').toString() : null;

    const closingLine = nextCall
      ? `I have our next call scheduled for ${nextCall}. If you have any questions or need anything from me before then, please don’t hesitate to reach out. You can also keep track of your campaigns by logging into REACH: https://my.reach.marketing.`
      : 'If you have any questions or need anything from me, please don’t hesitate to reach out. You can also keep track of your campaigns by logging into REACH: https://my.reach.marketing.';
    
    return [
      `Hi ${firstName},`,
      '',
      'Thank you for taking the time to speak with me today. Here is a brief recap of what we went over:',
      callNotes,
      '',
      'From our call, I’ve noted the following action items:',
      nextAction,
      '',
      closingLine,
      '',
      'Best,',
      assignedFirstName,
    ].join('\n').trim();
  }

  private formatCampaignAuditInternalNote(items: string[], additionalInfo?: string): string {
    const cleaned = (items ?? []).map(x => String(x ?? '').trim()).filter(Boolean);
    const extra = String(additionalInfo ?? '').trim();
    const lines: string[] = [];

    if (cleaned.length > 0) {
      lines.push('Campaign Audit Items Checked:', ...cleaned.map(i => `- ${i}`));
    }

    if (extra) {
      if (lines.length > 0) {
        lines.push('');
      }
      lines.push('Additional Information:', extra);
    }

    return lines.join('\n').trim();
  }

  private formatRedAlertDeepDiveInternalNote(items: string[]): string {
    const cleaned = (items ?? []).map(x => String(x ?? '').trim()).filter(Boolean);
    if (cleaned.length === 0) return '';

    const deepDive: string[] = [];
    const actions: string[] = [];
    let deepDiveNotes: string | null = null;
    let actionNotes: string | null = null;

    const ddPrefix = 'additional information regarding findings:';
    const actPrefix = 'additional information about actions taken:';

    for (const raw of cleaned) {
      const lower = raw.toLowerCase();

      if (lower.startsWith(ddPrefix)) {
        const text = raw.substring(ddPrefix.length).trim();
        if (text) deepDiveNotes = text;
        continue;
      }

      if (lower.startsWith(actPrefix)) {
        const text = raw.substring(actPrefix.length).trim();
        if (text) actionNotes = text;
        continue;
      }

      const isAction =
        lower === 'fixed conversion tracking' ||
        lower === 'sent to strategy for review' ||
        lower.startsWith('reverted previous changes:') ||
        lower.startsWith('kpi problem found and corrected:');

      if (isAction) {
        actions.push(raw);
      } else {
        deepDive.push(raw);
      }
    }

    const lines: string[] = [];

    if (deepDive.length > 0 || deepDiveNotes) {
      lines.push('Investigation');
      if (deepDive.length > 0) {
        lines.push(...deepDive.map(i => `- ${i}`));
      }
      if (deepDiveNotes) {
        lines.push('', 'Additional information regarding findings:', deepDiveNotes);
      }
    }

    if (actions.length > 0 || actionNotes) {
      if (lines.length > 0) lines.push('');
      lines.push('Actions Taken');
      if (actions.length > 0) {
        lines.push(...actions.map(i => `- ${i}`));
      }
      if (actionNotes) {
        lines.push('', 'Additional information about actions taken:', actionNotes);
      }
    }

    if (lines.length === 0) {
      return cleaned.map(i => `- ${i}`).join('\n').trim();
    }

    return lines.join('\n').trim();
  }

  private buildMissedCallEmailBody(callNote: any): string {
    const firstName = (callNote?.clientFirstName ?? '').toString().trim();
    const callNotes = (callNote?.callNotes ?? '').toString().trim();
    const nextAction = (callNote?.nextAction ?? '').toString().trim();
    const assignedFirstName = (callNote?.assignedUserFirstName ?? '').toString().trim();

    return [
      `Hi ${firstName},`,
      '',
      'Looks like we weren’t able to connect for our scheduled call. Let me know what works best for you to reschedule.',
      '',
      'I do want to share some updates with you regarding your campaign(s):',
      callNotes,
      '',
      'Here are the upcoming action items I have set for your campaign(s):',
      nextAction,
      '',
      'Again, please let me know when we can reschedule our call. If you have any questions or need anything from me, please don`t hesitate to reach out. You can also keep track of your campaigns by logging into REACH: https://my.reach.marketing.',
      '',
      'Best,',
      assignedFirstName,
    ].join('\n').trim();
  }

  private tryMarkTaskComplete(taskId: string | null | undefined): Promise<void> {
    const id = (taskId ?? '').toString().trim();
    if (!id) return Promise.resolve();

    return new Promise<void>((resolve) => {
      this.tasksApi.markTask({ id: id, isCompleted: true, completedOn: moment.utc().toDate() })
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: () => resolve(),
          error: () => resolve(),
        });
    });
  }

  private tryCreateNextCallTask(args: { clientId: string; dueDate: any; assignedUserId: string; description: string }): Promise<void> {
    const clientId = (args.clientId ?? '').toString().trim();
    const assignedUserId = (args.assignedUserId ?? '').toString().trim();
    const due = args.dueDate ? new Date(args.dueDate) : null;
    if (!clientId || !assignedUserId || !due || isNaN(due.getTime())) return Promise.resolve();

    const assignedUser = (this.allUsers ?? []).find(u => (u as any)?.id === assignedUserId) as any;
    const assignedUserName = `${assignedUser?.firstName ?? ''} ${assignedUser?.lastName ?? ''}`.trim();

    const payload: any = {
      id: createGuid(),
      title: 'Call With Client',
      priority: 2,
      campaignId: null,
      clientId,
      dueDate: Utility.getTaskDueDateFromDateTime(due),
      description: args.description ?? '',
      assignedUserId,
      assignedUserName,
      completedOn: null,
      isCompleted: false,
    };

    return new Promise<void>((resolve) => {
      this.tasksApi.saveTask(payload)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: () => resolve(),
          error: (e) => {
            console.error('Error creating next Call With Client task:', e, payload);
            resolve();
          },
        });
    });
  }

  private openSendEmailModalFromCallNote(args: { clientId: string; callNote: any }): void {
    const { clientId, callNote } = args;

    const isMissedCall = !!callNote?.sendMissedCallEmail;
    const subject = isMissedCall ? 'Missed Call' : 'Call Recap';
    const noteTitle = isMissedCall ? 'Missed Call Note' : 'Call Note';
    const body = isMissedCall ? this.buildMissedCallEmailBody(callNote) : this.buildCallRecapEmailBody(callNote);

    const emailRef = this.modalService.open(SendEmailModal, {
      size: 'xl',
      backdrop: 'static',
    });

    emailRef.componentInstance.iClientId = clientId;
    emailRef.componentInstance.iCampaignId = '';
    emailRef.componentInstance.iType = NOTES_TYPE.Clients;
    emailRef.componentInstance.iSubject = subject;

    emailRef.componentInstance.iNote = {
      title: noteTitle,
      description: body,
      isInternal: false,
      pin: false,
    } as any;

    emailRef.componentInstance.iFromName = `${callNote?.assignedUserFirstName ?? ''} ${callNote?.assignedUserLastName ?? ''}`.trim();
  }

  openCallNoteModal(evt: any): void {
    const clientId = evt?.clientId;

    if (!clientId) {
      this.openTaskEditModal(evt);
      return;
    }

    const dialogRef = this.modalService.open(AddCallNoteModal, {
      size: 'xl',
      windowClass: '',
      backdrop: 'static',
    });

    dialogRef.componentInstance.iClientId = clientId;
    dialogRef.componentInstance.iType = NOTES_TYPE.Clients;
    dialogRef.componentInstance.iTask = evt;

    dialogRef.componentInstance.oSaveClicked
      .pipe(takeUntil(this.destroyed$))
      .subscribe(async (request: any) => {
        // 1) Complete the triggering task
        const triggerTaskId = (evt?.id ?? request?.taskIdToComplete ?? '').toString();
        await this.tryMarkTaskComplete(triggerTaskId);

        // 2) If follow-up is specified, create the next Call With Client task
        const nextDue = request?.addTaskDate;
        const nextAssigneeId = request?.nextTaskAssignedUserId;
        if (nextDue && nextAssigneeId) {
          await this.tryCreateNextCallTask({
            clientId,
            dueDate: nextDue,
            assignedUserId: nextAssigneeId,
            description: 'Meeting with the client.',
          });
        }

        dialogRef.dismiss();
        this.loadTaskData();

        // 3) Open Call Recap email modal (this creates the "Call Note" note + sends the email)
        this.openSendEmailModalFromCallNote({ clientId, callNote: request });
      });

    dialogRef.componentInstance.oTaskUpdated
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.loadTaskData();
      });
  }

  doSearch(event: any) {
    this.searchString = event.target.value;
    this.loadTaskData();
  }

  filterByUser(userId: string | null): void {
    // this.selectedAutomationId = null;
    const selectedUser = this.allUsers.find(user => user.id === userId);
    if (selectedUser) {
      this.myTasks = true;
      if (this.searchString === '') {
        let search = selectedUser.lastName ? selectedUser.lastName.split(/[^a-zA-Z]/)[0] : '';
        this.loadTaskData(search);
      } else {
        this.loadTaskData();
      }
    } else {
      this.myTasks = false;
      this.loadTaskData();
    }
  }

  filterByAutomation(automationId: number | null): void {
    // this.selectedAutomationId = automationId;
    // this.selectedUserId = null;
    this.loadTaskData();
  }
 
}
